import { service } from '../services/request';

export function createAppointmentLog(data: any) {
    return service.post('/api/v1/appointment_logs', data);
}
